module.exports = __webpack_public_path__ + "static/media/info_gray.287317a6.svg";